import type { FileListResponse } from '@/types'

const NODE1 = 'aaaaaaaa-0001-0001-0001-000000000001'
const NODE3 = 'aaaaaaaa-0003-0003-0003-000000000003'

const ALL_FILES: FileListResponse['items'] = [
  {
    id: 'ffffffff-0001-0001-0001-000000000001',
    file_name: '20260519_090000.mp4',
    upload_target_file_name: null,
    local_path: '/data/manual/cam0/20260519_090000.mp4',
    file_kind: 'recording',
    camera_key: 'cam0',
    size_bytes: 1073741824,
    recorded_at: new Date(Date.now() - 600000).toISOString(),
    upload_status: 'pending',
    delete_status: 'none',
    failure_reason: null,
    deleted_at: null,
    delete_origin: null,
    delete_failure_reason: null,
    uploaded_at: null,
    nas_path: null,
    possibly_truncated: false,
    duration_seconds: 600,
    fps: 30,
    width: 1920,
    height: 1080,
    codec: 'h264',
  },
  {
    id: 'ffffffff-0002-0002-0002-000000000002',
    file_name: '20260519_083000.mp4',
    upload_target_file_name: null,
    local_path: '/data/manual/cam0/20260519_083000.mp4',
    file_kind: 'recording',
    camera_key: 'cam0',
    size_bytes: 2147483648,
    recorded_at: new Date(Date.now() - 4200000).toISOString(),
    upload_status: 'uploaded',
    delete_status: 'none',
    failure_reason: null,
    deleted_at: null,
    delete_origin: null,
    delete_failure_reason: null,
    uploaded_at: new Date(Date.now() - 900000).toISOString(),
    nas_path: '/cctv/site-a/rpi-a01/20260519/jjjjjjjj-0001/20260519_083000.mp4',
    possibly_truncated: false,
    duration_seconds: 600,
    fps: 30,
    width: 1920,
    height: 1080,
    codec: 'h264',
  },
  {
    id: 'ffffffff-0003-0003-0003-000000000003',
    file_name: '20260518_143000.mp4',
    upload_target_file_name: null,
    local_path: '/data/manual/cam1/20260518_143000.mp4',
    file_kind: 'recording',
    camera_key: 'cam1',
    size_bytes: 536870912,
    recorded_at: new Date(Date.now() - 90000000).toISOString(),
    upload_status: 'failed',
    delete_status: 'none',
    failure_reason: 'network timeout',
    deleted_at: null,
    delete_origin: null,
    delete_failure_reason: null,
    uploaded_at: null,
    nas_path: null,
    possibly_truncated: false,
    duration_seconds: 600,
    fps: 30,
    width: 1280,
    height: 720,
    codec: 'h264',
  },
  {
    id: 'ffffffff-0004-0004-0004-000000000004',
    file_name: '20260518_150000.mp4',
    upload_target_file_name: null,
    local_path: '/data/manual/cam1/20260518_150000.mp4',
    file_kind: 'recording',
    camera_key: 'cam1',
    size_bytes: 314572800,
    recorded_at: new Date(Date.now() - 86400000).toISOString(),
    upload_status: 'pending',
    delete_status: 'none',
    failure_reason: null,
    deleted_at: null,
    delete_origin: null,
    delete_failure_reason: null,
    uploaded_at: null,
    nas_path: null,
    possibly_truncated: true,
    duration_seconds: null,
    fps: null,
    width: null,
    height: null,
    codec: null,
  },
  {
    id: 'ffffffff-0005-0005-0005-000000000005',
    file_name: '20260519_100000.mp4',
    upload_target_file_name: null,
    local_path: '/data/manual/cam0/20260519_100000.mp4',
    file_kind: 'recording',
    camera_key: 'cam0',
    size_bytes: 1610612736,
    recorded_at: new Date(Date.now() - 3600000).toISOString(),
    upload_status: 'uploaded',
    delete_status: 'none',
    failure_reason: null,
    deleted_at: null,
    delete_origin: null,
    delete_failure_reason: null,
    uploaded_at: new Date(Date.now() - 1800000).toISOString(),
    nas_path: '/cctv/site-b/rpi-b01/20260519/jjjjjjjj-0002/20260519_100000.mp4',
    possibly_truncated: false,
    duration_seconds: 600,
    fps: 30,
    width: 1920,
    height: 1080,
    codec: 'h264',
  },
]

const INFERENCE_FILES: FileListResponse['items'] = [
  {
    id: 'eeeeeeee-0001-0001-0001-000000000001',
    file_name: '20260603_222747_225747_cam0.mp4',
    upload_target_file_name: null,
    local_path: '/home/node/output_video/cam0/20260603_222747_225747_cam0.mp4',
    file_kind: 'inference_recording',
    camera_key: 'cam0',
    size_bytes: 3221225472,
    recorded_at: new Date(Date.now() - 7200000).toISOString(),
    upload_status: 'pending',
    delete_status: 'none',
    failure_reason: null,
    deleted_at: null,
    delete_origin: null,
    delete_failure_reason: null,
    uploaded_at: null,
    nas_path: null,
    possibly_truncated: false,
    duration_seconds: 1800,
    fps: 30,
    width: 1920,
    height: 1080,
    codec: 'h264',
  },
  {
    id: 'eeeeeeee-0002-0002-0002-000000000002',
    file_name: '20260603_222747_225747_cam1.mp4',
    upload_target_file_name: null,
    local_path: '/home/node/output_video/cam1/20260603_222747_225747_cam1.mp4',
    file_kind: 'inference_recording',
    camera_key: 'cam1',
    size_bytes: 2147483648,
    recorded_at: new Date(Date.now() - 7200000).toISOString(),
    upload_status: 'failed',
    delete_status: 'none',
    failure_reason: 'FTP connection lost',
    deleted_at: null,
    delete_origin: null,
    delete_failure_reason: null,
    uploaded_at: null,
    nas_path: null,
    possibly_truncated: false,
    duration_seconds: 1800,
    fps: 15,
    width: 1920,
    height: 1080,
    codec: 'h264',
  },
]

export function mockFiles(
  nodeId?: string,
  fileKind: 'recording' | 'inference_recording' = 'recording',
  params?: {
    localState?: 'present' | 'deleted' | 'all'
    cameraKeys?: string[]
    limit?: number
    offset?: number
  },
): FileListResponse {
  let items = fileKind === 'inference_recording' ? INFERENCE_FILES : ALL_FILES
  if (nodeId === NODE1) items = ALL_FILES.slice(0, 4)
  else if (nodeId === NODE3) items = ALL_FILES.slice(4)
  else if (nodeId) items = []
  if (fileKind === 'inference_recording' && nodeId === NODE1) items = INFERENCE_FILES
  else if (fileKind === 'inference_recording') items = []
  if (params?.localState === 'deleted') {
    items = items.filter((file) => file.local_path == null && file.delete_status === 'deleted')
  } else if (params?.localState !== 'all') {
    items = items.filter((file) => file.local_path != null)
  }
  if (params?.cameraKeys) {
    const allowedCameraKeys = new Set(params.cameraKeys)
    items = items.filter((file) => file.camera_key != null && allowedCameraKeys.has(file.camera_key))
  }
  const total = items.length
  const offset = Math.max(0, params?.offset ?? 0)
  const limit = params?.limit == null ? total : Math.max(0, params.limit)
  return { items: items.slice(offset, offset + limit), total }
}
